import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'
import { TicketEditor, TicketComments, FileWidget } from 'projects/access-gui/components'
import { ContentHeader, NoContentBox } from 'components/basic'
import { notify } from 'helpers'
import http from 'API/http'

class Ticket extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ticket: null,
      access: {},
      lastUpdated: Date.now()
    }
  }

  async componentDidMount () {
    this.getTicket(this.props.match.params.ticketId)
  }
  async componentWillReceiveProps (nextProps) {
    if (this.props.match.params.ticketId === nextProps.match.params.ticketId) return
    this.getTicket(nextProps.match.params.ticketId)
  }

  async getTicket (id) {
    var [err, ticket] = await http.get('2.4/tickets/' + id, { detailed: true })
    if (err) return notify.alert('', err.message, 'error')
    var [err, access] = await http.get('2.4/accesses/' + ticket.data.accessId)
    if (err) access.data = {accessId: 'Unable to fetch access'}
    this.setState({lastUpdated: Date.now(), ticket: {...ticket.data, title: ReactHtmlParser(ticket.data.title), access: access.data}})
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: ' Ticket - ' + ticket.data.spTicketReference
    })
  }

  render () {
    if (!this.state.ticket) {
      return (
        <div className='content-wrapper flexbox-absolute-center'>
          <NoContentBox icon='circle-o-notch fa-spin' text='Loading Ticket' />
        </div>
      )
    }
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Ticket' subtitle={this.state.ticket.spTicketReference} buttons={[
          { icon: 'fa-home', event: () => (window.location.hash = '/access/' + this.state.ticket.accessId), tip: 'Access' },
          { icon: 'fa-ticket', event: () => (window.location.hash = '/ticket'), tip: 'Ticket Overview' }
        ]} />
        <hr />
        <div className='row'>
          <TicketEditor callback={() => this.getTicket(this.props.match.params.ticketId)} ticket={this.state.ticket} lastUpdated={this.state.lastUpdated} />
          <TicketComments callback={() => this.getTicket(this.props.match.params.ticketId)} ticket={this.state.ticket} lastUpdated={this.state.lastUpdated} />
          <FileWidget id={this.state.ticket.ticketId} namespace='ticket/ticket' />
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
Ticket = connect(state => state.siteReducer)(Ticket)
export default Ticket



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/ticket/ticket.js